import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BuyerService } from '../services/buyer.service';
import { LookupService } from '../services/lookup.service';

@Injectable({ providedIn: 'root' })
export class DashboardRedirectGuard implements CanActivate {
  constructor(
    private lookupService: LookupService,
    private buyerService: BuyerService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requestedDashboard2 = route.routeConfig?.path === 'dashboard2';
    const routeResult = (dashboard2Enabled: boolean): boolean | UrlTree => {
      if (requestedDashboard2) {
        return dashboard2Enabled ? true : this.router.createUrlTree(['/dashboard']);
      }

      return dashboard2Enabled ? this.router.createUrlTree(['/dashboard2']) : true;
    };

    return this.lookupService.getSettings$('FeatureToggle').pipe(
      switchMap(settings => {
        const dashboardSetting = settings.find(setting => setting.key === 'PledgeDashboardRegions');
        const enabledRegions = dashboardSetting?.value;

        if (!enabledRegions) {
          return of(routeResult(false));
        }

        if (enabledRegions === 'all') {
          return of(routeResult(true));
        }

        return from(this.buyerService.getCurrentBuyer()).pipe(
          map(buyer => {
            const dashboard2Enabled = buyer && enabledRegions
              .split(',')
              .some(regionId => regionId === buyer.regionId.toString());

            return routeResult(!!dashboard2Enabled);
          })
        );
      }),
      catchError(() => of(routeResult(false)))
    );
  }
}